import { generateUtilityClass, generateUtilityClasses } from '@mui/material';

export function getUtilityClass(slot: string): string {
  return generateUtilityClass('Label', slot);
}

// generateUtilityClasses가 이미 타입을 제공하므로 별도 인터페이스 불필요
export const labelClasses = generateUtilityClasses('Label', [
  'root',
  'refetch',
  'label',
  'container',
  'requireMark',
  'numberIndex',
  'info',
  'description',
  'expandable',
  'clickableArea',
]);
